import * as _ from "lodash";

class ConfigurationManager {
    constructor() {
        this.values = {};
        this.setFloorSpace = this.setFloorSpace.bind(this);
    }

    values = {};

    getParameter(params, key) {
        const parameters = _.fromPairs(
            _.replace(params, /\?/g, "")
                .split("&")
                .map((parameter) => parameter.split("=")),
        );
        return parameters[key];
    }

    async refreshConfigurationFile() {
        const mode = import.meta.env.MODE ?? "debug";
        const config = await import(`../../config/config.${mode}.json`);

        this.values = {
            ...this.values,
            ...config,
            api: config.useSecureApi ? config.api : config.unsecureApi,
        };
    }

    async setFloorSpace(location) {
        const floorSpaceId = this.getParameter(location.search, "floorspace");
        const partnerKey = this.getParameter(location.search, "partner-key");
        const orgKey = this.getParameter(location.search, "org-key");
        const commissionerMode = this.getParameter(
            location.search,
            "commissionerMode",
        );

        if (!floorSpaceId || !partnerKey || !orgKey) {
            window.location.href = this.values.adminUrl;
            return;
        }

        this.values = {
            rootPath: location.path,
            ...this.values,
            partnerKey,
            orgKey,
            floorSpaceId: parseInt(floorSpaceId, 10),
            commissionerMode,
        };
    }
}

export default new ConfigurationManager();
